import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) =>
  createStyles({
    head: {
      fontSize: 14,
    },
    body: {
      fontSize: 14,
    },
    root: {
      "&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    viewPhasePlan: {
      backgroundColor: "#fff",
      padding: "30px 25px",
    },
    phaseFooterFixed: {
      "&>div": {
        height:'initial',
        display: 'none',
        "&>div:nth-of-type(2)": {
          position: "fixed",
          width: "calc(100% - 84px)",
          height: 76,
          right: 0,
          display: "flex",
          alignItems: "center",
          padding: "0 30px",
          left: "initial",
          boxShadow: "8px -2px 10px rgba(0, 0, 0, 0.12)",        
        },
        "&>div:nth-of-type(1)": {
          display: "none",       
        },
      },
    },
    examContainer: {
      display: "flex",
      flexDirection: "column",
      '& p:nth-of-type(1)':{
        display: 'flex',
      }
    },
    examDate: {
      paddingLeft: 25,
    },
    tableWrapper:{
      '& thead':{
        '& th':{
          fontSize: 16,
          color: '#666',
          fontWeight: 400,
          paddingLeft: 0,
          border: 'none',
        },
      },
      '& tbody':{
        '& tr:nth-of-type(even)':{
          backgroundColor: '#F8F8F8',          
        },
        '& tr':{
          '& td':{
            fontSize: 16,
            color: '#333',
            fontWeight: 400,
            paddingLeft: 0,
            border: 'none',
          },
          '& th':{
            fontSize: 16,
            color: '#333',
            fontWeight: 400,
            paddingLeft: 10,
            border: 'none',
          },
        }
      }
    },
    MainHeading:{
      fontSize: 24,
      color: '#333',
      lineHeight: '33px',
      marginBottom: 14,
    },
    courseDuration:{
      fontSize: 16,
      lineHeight: '20px',
      color: '#666',
      marginBottom: 10
    },
    countPhase:{
      fontSize: 16,
      lineHeight: '22px',
      color: '#333'
    },
    boldData:{
      fontWeight: 600
    }
  });
const useStyles = () => createStyles({
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(even)': {
      backgroundColor: '#F8F8F8',
    },
  },
});

export { styles , useStyles };


